import { render } from "./shareAlbum.vue?vue&type=template&id=1503058c&scoped=true"
import script from "./shareAlbum.vue?vue&type=script&lang=js"
export * from "./shareAlbum.vue?vue&type=script&lang=js"

import "./shareAlbum.vue?vue&type=style&index=0&id=1503058c&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1503058c"]])

export default __exports__